import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Get, Post, Error } from "../../../Services/Server";
import Url from "../../../Services/Url";
import Button from "../../../Components/Button/Button";
import { toast } from "react-toastify";
import css from "./PaymentTerms.module.css";
import Head from "../../../Components/Head/Head";

const PaymentTermsView = () => {
	const { id } = useParams();
	const [initial, setInitial] = useState(null);
	const [initialId, setInitialId] = useState(null);

	useEffect(() => {
		if (id) {
			Get(Url.sales.getInitialContract(id))
				.then((response) => {
					console.log(response);

					setInitial(response);
					setInitialId(response.id);
				})
				.catch((err) => {
					toast("Failed to load payment term details.");
				});
		}
	}, [id]);

	const handleApprove = () => {
		sendApprovalDecision("approved");
	};

	const handleDisapprove = () => {
		sendApprovalDecision("disapproved");
	};

	const sendApprovalDecision = (decision) => {
		if (!initial) return;

		Post(Url.sales.updatePaymentTerm, {
			initialId: parseInt(initialId, 10),
			decision: decision,
			// comments: approvalComments, // Removed comments for now
		})
			.then(() => {
				toast(`Term ${decision}`);
				fetchPaymentTermDetails();
			})
			.catch((err) => {
				Error(err);
				console.error("Error sending approval decision:", err);
				toast("Failed to send approval decision.");
			});
	};

	const fetchPaymentTermDetails = () => {
		if (id) {
			Get(Url.sales.getInitialContract(id))
				.then((response) => {
					setInitial(response);
				})
				.catch((err) => {
					toast("Error refreshing term details:", err);
				});
		}
	};

	return (
		<div className="TaskDetails">
			<div className="TDLeft">
				<Head title={`Payment Term`} />
				<div className="Main">
					<div className="GeneralTaskInfo">
						<div>
							<div>Company</div>
							<div>{`${initial?.company?.name}` || "-"}</div>
						</div>
						<div>
							<div>Job</div>
							<div>
								{`${initial?.equipment[0]?.service.name} of ${initial?.equipment[0]?.equipment}` ||
									"-"}
							</div>
						</div>

						<div>
							<div>Payment Term</div>
							<div>{initial?.paymentTerm?.paymentTerm?.name || "-"}</div>
						</div>
						{initial?.paymentTerm?.approvalStatus?.name == "approved" && (
							<div>
								<div>Approved By</div>
								<div>
									{initial?.paymentTerm?.approvalStatus?.approvedBy.fullName ||
										"-"}
								</div>
							</div>
						)}
						{initial?.paymentTerm?.approvalStatus?.name == "disapproved" && (
							<div>
								<div>Disapproved By</div>
								<div>
									{initial?.paymentTerm?.approvalStatus?.approvedBy.fullName ||
										"-"}
								</div>
							</div>
						)}
					</div>

					{initial?.paymentTerm?.approvalStatus?.name == "pending" && (
						<div className="TaskDetailsBtns">
							<div>
								<Button className="Active Btn-Mid" onClick={handleApprove}>
									Approve Term
								</Button>
							</div>
							<div>
								<Button className="Inverse Btn-Mid" onClick={handleDisapprove}>
									Disapprove Term
								</Button>
							</div>
						</div>
					)}
				</div>
			</div>
			<div className="TDRight">
				{/* You can add a right section here if needed, like the TaskDetails */}
			</div>
		</div>
	);
};

export default PaymentTermsView;
